<template>
    <div id="sub-step-result-label" style="justify-content: space-between;">
        <h2 id="result-label" style="width: 100%; overflow: hidden"><span class="result-label-text">{{ resultLabel }}</span><span style="overflow: hidden;display:none">..................................................................................................................................................</span></h2>
        <h2 id="step-result" style="padding-left: 0; margin-left: 0; float: right"> <span v-show="!resultNotCalculated">${{ displayStepResult }}</span><span v-show="resultNotCalculated" class="result-error">{{ resultError }}</span></h2>
    </div>
</template>

<script>
    export default {
        name: "sub-step-result-label",
        props: {
            resultLabel: String,
            stepResult: Number,
            resultError: {
                default: '',
                type: String
            }
        },
        computed: {
            resultNotCalculated () {
                return this.resultError !== '';
            },
            displayStepResult () {
                return this.stepResult.toLocaleString('en-US',{useGrouping:true});
            }
        }
    }
</script>

<style scoped>

    #sub-step-result-label {
        display: flex;
        width: 95%;
        margin: 0 auto;
        background: rgb(237, 239, 241);
        padding-left: 5%;
        padding-right: 5%;
        margin-bottom: 15px;
        justify-content: space-between
    }

    #result-label {
        align-self: flex-end;
        float: left;
        text-align: left;
        padding-left: 0;
        font-size: 20px;
        margin-bottom: 0;
    }

    #step-result {
        align-self: flex-end;
        margin-left: auto;
        direction: rtl;
        word-wrap: break-word;
        font-size: 20px;
        margin-bottom: 0;
        white-space: nowrap;
    }

    .result-error {
        color: #ee3124;
    }

    h2 {
        font-family: 'Roboto', Arial, serif;
        color: #465978;
        padding-left: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        font-weight: bold;
        text-align: right;
    }

    .interest-result #result-label, .total-expenses #result-label  {
        text-transform: none !important;
    }

    @media (min-width: 1150px) {
        .result-label-text {
            white-space: nowrap;
        }
    }

    @media (min-width: 900px) {
        .total-expenses .result-label-text {
            white-space: nowrap;
        }
    }

    @media (min-width: 1024px) {
        #sub-step-result-label {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
            padding-left: 4%;
            padding-right: 4%;
            display: flex;
            margin-bottom: 0;
        }

        .estimated-depreciation-amount {
            margin-bottom: 15px !important;
        }

        #result-label {
            width: 52%;
            align-self: flex-end;
        }

        #step-result {
            align-self: flex-end;
        }
    }

    @media (max-width: 670px) {
        #result-label {
            font-size: 20px;
        }

        #step-result {
            font-size: 20px;
        }
    }

    @media (min-width: 541px) and (max-width: 1023px) {
        .result-label-text {
            white-space: nowrap;
        }
    }

    @media (max-width: 540px) {
        #sub-step-result-label {
            display: flex;
        }

        #result-label {
            width: 52%;
            align-self: flex-end;
        }

        #step-result {
            align-self: flex-end;
        }

        .result-label-text {
            white-space: nowrap;
        }

        .interest-on-equity-funds .result-label-text {
            white-space: normal;
        }
    }

</style>


// WEBPACK FOOTER //
// src/Components/SubStepResultLabel.vue